import ReactAce from "./ace.mjs";
import SplitComponent from "./split.mjs";
import DiffComponent from "./diff.mjs";
//#region src/index.ts
var src_default = ReactAce;
//#endregion
export { src_default as default, DiffComponent as diff, SplitComponent as split };

//# sourceMappingURL=index.mjs.map